import { render, staticRenderFns } from "./ParamsManage.vue?vue&type=template&id=33298174&scoped=true"
import script from "./ParamsManage.vue?vue&type=script&lang=js"
export * from "./ParamsManage.vue?vue&type=script&lang=js"
import style0 from "./ParamsManage.vue?vue&type=style&index=0&id=33298174&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33298174",
  null
  
)

export default component.exports